import { X, Navigation } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../context/ProfileContext";

const SAPProfileIncompleteModal = () => {
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => setIsOpen(false);
  const navigate = useNavigate();
  const { profileStatus, checkUserProfile } = useProfile();

  // Detect which tab to open based on backend message
  const getTabFromMessage = () => {
    const rawMsg = profileStatus?.message || profileStatus?.error;

    if (!rawMsg || typeof rawMsg !== "string") {
      return "Primary Information"; // default safe fallback
    }

    const msg = rawMsg.toLowerCase(); // case-insensitive match

    if (msg.includes("personal")) return "Primary Information";
    if (msg.includes("academic")) return "Academics";
    if (msg.includes("test")) return "Test Scores";
    if (msg.includes("preference")) return "Preferences";
    if (msg.includes("document")) return "Documents";

    return "Primary Information"; // fallback if nothing matched
  };

  useEffect(() => {
    checkUserProfile();
  }, []);

  // Auto redirect after 5 sec
  useEffect(() => {
    const timer = setTimeout(() => {
      const tab = getTabFromMessage();
      navigate(`/sap/profile?tab=${encodeURIComponent(tab)}`);
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, profileStatus]);

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-[1100] bg-black/50">
          <div className="bg-white mt-20 rounded-2xl shadow-lg max-w-xl w-full p-8 relative">
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-[#572575] transition-colors"
              aria-label="Close"
            >
              <X size={22} />
            </button>

            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="p-1 rounded-full">
                <img
                  src="/PremiumAccess/MissingProfile.png"
                  alt="square"
                  className="h-16 w-auto"
                />
              </div>
            </div>

            <h2 className="font-inter text-[#8A40B5] text-[22px] font-normal text-center leading-[14px]">
              Warning
            </h2>

            <p className="font-inter mt-4 text-[#444444] text-[16px] font-normal leading-[16px] text-center mb-6">
              {profileStatus?.error ||
                profileStatus?.message ||
                "Please complete your profile to proceed with the course application."}
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() =>
                  navigate(
                    `/sap/profile?tab=${encodeURIComponent(
                      getTabFromMessage()
                    )}`
                  )
                }
                className="px-4 py-2 bg-[#572575] text-white rounded-lg font-altis font-bold text-[14px] leading-[14px] flex items-center gap-2 hover:bg-[#572575] transition"
              >
                <Navigation /> Navigate to Profile Section
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SAPProfileIncompleteModal;
